module.exports = __webpack_public_path__ + "img/silo_full.b61d0c9a.jpeg";